export default __webpack_public_path__ + "static/icon-10-5-053fb240e4a76ab619d583b5684c2620.png";